module.exports = __webpack_public_path__ + "img/globe_icon.2668a30d.svg";